import React from 'react';
import { ValidatedSelect, ValidatedSelectItem } from '@cp-shared-19/frontend-ui';

type BalanceReasonSelectionProps = {
    label: string;
    name: string;
    customerType: 'SME' | 'PM' | 'BIC' | 'BA' | 'BNC' | 'Retail';
    isMandatory?: boolean;
    selectId?: string;
};

export const BalanceReasonSelection: React.FC<BalanceReasonSelectionProps> = ({
    label,
    name,
    isMandatory = true,
    selectId,
    customerType,
}) => {
    let balanceReasons: string[] = [];

    // "Retail" : 4 reasons:
    const retailReasons: string[] = ['Crédit', 'Donation/héritage', 'Epargne', 'Gain aux jeux'];
    // "BIC/BA/BNC": 8 reasons:
    const bReasons: string[] = [
        'Donation/héritage',
        'Epargne',
        'Gain aux jeux',
        'Ventes d’un bien immobilier',
        'Crédit',
        'Vente de parts de société',
        'Distribution de dividendes',
        'Trésorerie',
    ];
    // "PM": 5 reasons:
    const pmReasons: string[] = [
        'Ventes d’un bien immobilier',
        'Crédit',
        'Vente de parts de société',
        'Distribution de dividendes',
        'Trésorerie',
    ];

    switch (customerType) {
        case 'Retail':
            balanceReasons = retailReasons;
            break;
        case 'BIC':
        case 'BA':
        case 'BNC':
            balanceReasons = bReasons;
            break;
        case 'PM':
            balanceReasons = pmReasons;
            break;
    }

    const selectItems: ValidatedSelectItem[] = balanceReasons.map((balanceReason: string) => {
        return { value: balanceReason, label: balanceReason };
    });

    return (
        <ValidatedSelect
            className="c-form-field--no-floating"
            label={label}
            name={name}
            id={selectId}
            testId={`test-${name}`}
            selectItems={selectItems}
            emptyByDefault
            required={isMandatory}
            isMandatory={isMandatory}
            requiredText=" *"
        />
    );
};
